var map = {
	"./en.json": 260,
	"./it.json": 261
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;



/*****************
 ** WEBPACK FOOTER
 ** ./web/locales ^\.\/.*\.json$
 ** module id = 259
 ** module chunks = 0
 **/